import AccountCreation from "@/components/signup/account-creation";
import { SignupBackgroundLayout } from "@/components/signup/layouts";
import { RovoDevAgentsLogo } from "@/components/signup/utils/get-rovo-dev-agents-logo";

import { GetStartedHeading } from "./components/get-started-heading";

export const LoggedOutDevAIFree = () => {
    return (
        <SignupBackgroundLayout ProductLogo={<RovoDevAgentsLogo />}>
            <GetStartedHeading />
            <AccountCreation />
        </SignupBackgroundLayout>
    );
};
